import "./style.css";
import { useTranslation } from "react-i18next";

const BusinessSamedayReschedulePolicy = ({
    className
}) => {
    const { t } = useTranslation();
    return (
        <div className={className}>
            <div className="d-none d-md-block">
                <table className="w-100" id="cancellationTable">
                    <tr>
                        <td colSpan={4} className="bg-gold-light2">
                            <p
                                className="m-0 fw-700"
                                dangerouslySetInnerHTML={{ __html: t("componentTnc.business.sameDayReschedulePolicy.title") }}
                            ></p>
                        </td>
                    </tr>
                    <tr style={{ borderBottom: "4px solid #56273A" }}>
                        <td className="bg-56273A">
                            <p className="fw-700 my-0 mx-4 text-gold">{t("componentTnc.business.sameDayReschedulePolicy.header.H1")}</p>
                        </td>
                        <td className="bg-F1F1F2">
                            <p className="my-0 mx-4"
                                dangerouslySetInnerHTML={{
                                    __html: t("componentTnc.business.sameDayReschedulePolicy.header.H2"),
                                }}
                            ></p>
                        </td>
                        <td className="bg-E6E7E8">
                            <p className="my-0 mx-4"
                                dangerouslySetInnerHTML={{
                                    __html: t("componentTnc.business.sameDayReschedulePolicy.header.H3"),
                                }}
                            ></p>
                        </td>
                        <td className="bg-DCDDDE">
                            <p className="my-0 mx-4"
                                dangerouslySetInnerHTML={{
                                    __html: t("componentTnc.business.sameDayReschedulePolicy.header.H4"),
                                }}
                            ></p>
                        </td>
                    </tr>
                    <tr>
                        <td className="bg-D3CCCE">
                            <p
                                className="my-0 mx-3"
                                dangerouslySetInnerHTML={{
                                    __html: t("componentTnc.business.sameDayReschedulePolicy.content.R1.T1"),
                                }}
                            ></p>
                        </td>
                        <td
                            colSpan={3}
                            className="bg-F9F9F9"
                        >
                            <p className="my-0 mx-3"
                                dangerouslySetInnerHTML={{
                                    __html: t("componentTnc.business.sameDayReschedulePolicy.content.R1.T2"),
                                }}
                            ></p>
                        </td>
                    </tr>
                    <tr>
                        <td className="bg-CAC3C6">
                            <p
                                className="my-0 mx-3"
                                dangerouslySetInnerHTML={{
                                    __html: t("componentTnc.business.sameDayReschedulePolicy.content.R2.T1"),
                                }}
                            ></p>
                        </td>
                        <td className="bg-F1F1F2 border-top-white" >
                            <p className="my-0 mx-3"
                                dangerouslySetInnerHTML={{
                                    __html: t("componentTnc.business.sameDayReschedulePolicy.content.R2.T2"),
                                }}
                            ></p>
                        </td>
                        <td className="bg-E6E7E8 border-top-white">
                            <p className="my-0 mx-3"
                                dangerouslySetInnerHTML={{
                                    __html: t("componentTnc.business.sameDayReschedulePolicy.content.R2.T3"),
                                }}
                            ></p>
                        </td>
                        <td className="bg-DCDDDE border-top-white">
                            <p className="my-0 mx-3"
                                dangerouslySetInnerHTML={{
                                    __html: t("componentTnc.business.sameDayReschedulePolicy.content.R2.T4"),
                                }}
                            ></p>
                        </td>
                    </tr>
                </table>
            </div>
            <div className="d-block d-md-none" style={{ overflowX: 'auto', WebkitOverflowScrolling: 'touch' }}>
                <div style={{ minWidth: '560px' }}>
                <table className="w-100" id="cancellationTable">
                    <tr>
                        <td colSpan={4} className="bg-gold-light2">
                            <p
                                className="m-0 fw-700"
                                dangerouslySetInnerHTML={{ __html: t("componentTnc.business.sameDayReschedulePolicy.title") }}
                            ></p>
                        </td>
                    </tr>
                    <tr style={{ borderBottom: "4px solid #56273A" }}>
                        <td className="bg-56273A">
                            <p className="fw-700 my-0 mx-2 text-gold">{t("componentTnc.business.sameDayReschedulePolicy.header.H1")}</p>
                        </td>
                        <td className="bg-F1F1F2">
                            <p className="my-0 mx-2"
                                dangerouslySetInnerHTML={{
                                    __html: t("componentTnc.business.sameDayReschedulePolicy.header.H2"),
                                }}
                            ></p>
                        </td>
                        <td className="bg-E6E7E8">
                            <p className="my-0 mx-2"
                                dangerouslySetInnerHTML={{
                                    __html: t("componentTnc.business.sameDayReschedulePolicy.header.H3"),
                                }}
                            ></p>
                        </td>
                        <td className="bg-DCDDDE">
                            <p className="my-0 mx-2"
                                dangerouslySetInnerHTML={{
                                    __html: t("componentTnc.business.sameDayReschedulePolicy.header.H4"),
                                }}
                            ></p>
                        </td>
                    </tr>
                    <tr>
                        <td className="bg-D3CCCE">
                            <p
                                className="my-0 mx-2"
                                dangerouslySetInnerHTML={{
                                    __html: t("componentTnc.business.sameDayReschedulePolicy.content.R1.T1"),
                                }}
                            ></p>
                        </td>
                        <td
                            colSpan={3}
                            className="bg-F9F9F9"
                        >
                            <p className="my-0 mx-2"
                                dangerouslySetInnerHTML={{
                                    __html: t("componentTnc.business.sameDayReschedulePolicy.content.R1.T2"),
                                }}
                            ></p>
                        </td>
                    </tr>
                    <tr>
                        <td className="bg-CAC3C6">
                            <p
                                className="my-0 mx-2"
                                dangerouslySetInnerHTML={{
                                    __html: t("componentTnc.business.sameDayReschedulePolicy.content.R2.T1"),
                                }}
                            ></p>
                        </td>
                        <td className="bg-F1F1F2 border-top-white" >
                            <p className="my-0 mx-2"
                                dangerouslySetInnerHTML={{
                                    __html: t("componentTnc.business.sameDayReschedulePolicy.content.R2.T2"),
                                }}
                            ></p>
                        </td>
                        <td className="bg-E6E7E8 border-top-white">
                            <p className="my-0 mx-2"
                                dangerouslySetInnerHTML={{
                                    __html: t("componentTnc.business.sameDayReschedulePolicy.content.R2.T3"),
                                }}
                            ></p>
                        </td>
                        <td className="bg-DCDDDE border-top-white">
                            <p className="my-0 mx-2"
                                dangerouslySetInnerHTML={{
                                    __html: t("componentTnc.business.sameDayReschedulePolicy.content.R2.T4"),
                                }}
                            ></p>
                        </td>
                    </tr>
                </table>
                </div>
            </div>
        </div>
    );
};

export default BusinessSamedayReschedulePolicy;
